import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loading-indicator',
  templateUrl: './loading-indicator.component.html',
  styleUrls: ['./loading-indicator.component.scss']
})
export class LoadingIndicatorComponent {
  @Input() isLoading: boolean = false;
  @Input() diameter: number = 50;
  @Input() type: 'Fixed' | 'Relative' | 'Absolute' = 'Fixed';
}
